export default "/dist/files/doc.b05f2622a72253cb7e337ee54ff01195.svg";